import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Admin from "./Admin";
import SelectionPage from "./SelectionPage";
import BloodCholesterolPage from "./BloodCholesterolPage";
import FullHealthScreenPage from "./FullHealthScreenPage";
import NurseChatPage from "./NurseChatPage";
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SelectionPage />} />
      <Route
        path="/screen"
        element={<Navigate to="/screen/full-health-screen" replace />}
      />
      <Route
        path="/screen/blood-cholesterol-checks"
        element={<BloodCholesterolPage />}
      />
      <Route
        path="/screen/full-health-screen"
        element={<FullHealthScreenPage />}
      />
      <Route path="/screen/nurse-chat" element={<NurseChatPage />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
